import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary
      errorMessage="The application encountered an unexpected error. Your data is safe and we're using offline mode."
      onError={(error, errorInfo) => {
        console.error('🚨 Top-level error caught by boundary:', error);
        // In production, send to error tracking service
        // Example: Sentry.captureException(error, { extra: errorInfo });
      }}
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
